import { render, staticRenderFns } from "./VideoDialogAd.vue?vue&type=template&id=4d43dac0&scoped=true"
import script from "./VideoDialogAd.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoDialogAd.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VideoDialogAd.vue?vue&type=style&index=0&id=4d43dac0&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d43dac0",
  null
  
)

export default component.exports